import { render } from "./LandPage.vue?vue&type=template&id=67629115"
import script from "./LandPage.vue?vue&type=script&lang=js"
export * from "./LandPage.vue?vue&type=script&lang=js"

import "./LandPage.vue?vue&type=style&index=0&id=67629115&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__